import { Page as BasePage } from './Page'
import { PageTitle } from './PageTitle'
import { Section } from './Section'

export * from './Page'
export * from './PageTitle'
export * from './Section'

export const Page = Object.assign(BasePage, { Title: PageTitle, Section })
